module.exports = __webpack_public_path__ + "5f2b0f815c1b244482bfe2f0e6c646c5.webp";